import { StyleSheet, View } from "react-native";
import { Text, Icon } from "react-native-paper";

import { colors } from "@/lib/theme";

interface VerificationStatusProps {
    status: string;
    rejectionReason?: string | null;
}

export function VerificationStatus({ status, rejectionReason }: VerificationStatusProps) {
    if (status === "ai_verifying" || status === "submitted") {
        return (
            <View style={[styles.container, styles.verifying]}>
                <View style={styles.spinnerWrap}>
                    <Icon source="loading" size={16} color={colors.warning} />
                </View>
                <Text style={[styles.text, { color: colors.warning }]}>Verifying...</Text>
            </View>
        );
    }

    if (status === "approved") {
        return (
            <View style={[styles.container, styles.approved]}>
                <Icon source="check-circle" size={16} color={colors.success} />
                <Text style={[styles.text, { color: colors.success }]}>Approved</Text>
            </View>
        );
    }

    if (status === "required") {
        return null;
    }

    if (status === "rejected") {
        return (
            <View>
                <View style={[styles.container, styles.rejected]}>
                    <Icon source="close-circle" size={16} color={colors.error} />
                    <Text style={[styles.text, { color: colors.error }]}>Rejected</Text>
                </View>
                {rejectionReason && (
                    <View style={styles.reasonBox}>
                        <Text style={styles.reasonText}>{rejectionReason}</Text>
                    </View>
                )}
            </View>
        );
    }

    if (status === "verification_failed") {
        return (
            <View>
                <View style={[styles.container, styles.rejected]}>
                    <Icon source="alert-circle" size={16} color={colors.error} />
                    <Text style={[styles.text, { color: colors.error }]}>
                        Verification failed — please re-upload
                    </Text>
                </View>
            </View>
        );
    }

    return null;
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderRadius: 8
    },
    verifying: {
        backgroundColor: colors.warningLight
    },
    approved: {
        backgroundColor: colors.successLight
    },
    required: {
        backgroundColor: colors.warningLight
    },
    rejected: {
        backgroundColor: colors.errorLight
    },
    text: {
        fontSize: 13,
        fontWeight: "600"
    },
    spinnerWrap: {
        // Rotation handled by the icon itself
    },
    reasonBox: {
        marginTop: 6,
        padding: 10,
        backgroundColor: colors.errorLight,
        borderRadius: 8
    },
    reasonText: {
        fontSize: 12,
        color: colors.error
    }
});
